import React, { useMemo } from 'react';

import {
  OverlayScrollbarsComponent,
  OverlayScrollbarsComponentProps,
  OverlayScrollbarsComponentRef,
} from 'overlayscrollbars-react';

import 'overlayscrollbars/overlayscrollbars.css';

import type { PartialOptions } from 'overlayscrollbars';

// OverlayScrollbars paints the bar as an overlay element (zero layout width), so it
// floats on top of content instead of reserving space like a styled
// ::-webkit-scrollbar would — adding/removing it never reflows the page, and the
// content stays full-width and centred with no gap on the right. The visual theme
// (`os-theme-cognito`) is defined in index.styles.ts against the design ramps.
const baseOptions: PartialOptions = {
  scrollbars: {
    theme: 'os-theme-cognito',
    autoHide: 'leave',
    autoHideDelay: 500,
  },
  overflow: {
    x: 'hidden',
    y: 'scroll',
  },
};

const Scrollbar = React.forwardRef<OverlayScrollbarsComponentRef, OverlayScrollbarsComponentProps>(
  ({ options, defer = true, ...props }, ref) => {
    const mergedOptions = useMemo<PartialOptions>(() => {
      if (!options) {
        return baseOptions;
      }
      return {
        ...baseOptions,
        ...options,
        scrollbars: { ...baseOptions.scrollbars, ...options.scrollbars },
        overflow: { ...baseOptions.overflow, ...options.overflow },
      };
    }, [options]);

    return (
      <OverlayScrollbarsComponent ref={ref} options={mergedOptions} defer={defer} {...props} />
    );
  }
);

Scrollbar.displayName = 'Scrollbar';

export default Scrollbar;
